import graphql__97ffb1e2e73171f8db48 from "./__generated__/DeleteEmailLayoutDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import FormDialog from "../dialog/FormDialog";
import type {DeleteEmailLayoutDialogMutation} from "./__generated__/DeleteEmailLayoutDialogMutation.graphql";
import {useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    emailLayout: {
        id: string
        emailLayoutIdentifier: string
        name: string
    }
    onClose: () => void
}

const DeleteEmailLayoutDialog: React.FC<Props> = ({emailLayout, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<DeleteEmailLayoutDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__97ffb1e2e73171f8db48,
                variables: {
                    input: {
                        id: emailLayout.emailLayoutIdentifier
                    }
                },
                updater: (store) => {
                    store.delete(emailLayout.id);
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose();
                    navigate('/marketing/layouts');
                },
                onError: (error) => {
                    console.error(error);
                    onClose();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteEmailLayout'})
            }
        )
    }

    return (
        <FormDialog handleCloseDialog={onClose}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.DeleteEmailLayoutDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    submitButtonVariant="danger">
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.DeleteEmailLayoutDialog.confirmMessage'}, {name: emailLayout.name})}
                </p>
            </Section>
        </FormDialog>
    )
}

export default DeleteEmailLayoutDialog;
